import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import {environment} from "../../../environments/environment";
import {ActivateAccountModel} from "../../shared/models/activate-account/activate-account";
import {SuccessModel} from "../../shared/models/success/success.model";
import {lang} from "../../shared/lang/lang.nl";
import {ApiService} from "../../core/api/api.service";

@Component({
    selector: 'bergh-activate-account',
    templateUrl: './activate-account.component.html',
    styleUrls: ['./activate-account.component.scss'],
    standalone: false
})
export class ActivateAccountComponent implements OnInit, OnDestroy {


  public lang = lang;
  public activateAccountForm: UntypedFormGroup;
  public token: string;
  public username: string;
  private tokenSubscription: Subscription;
  private usernameSubscription: Subscription;

  constructor( private _formBuilder: UntypedFormBuilder,
               private _route: ActivatedRoute,
               private _toastr: ToastrService,
               private _api: ApiService,
               private _router: Router ) { }

  ngOnDestroy(): void {
    this.tokenSubscription.unsubscribe();
    this.usernameSubscription.unsubscribe();
  }


  ngOnInit(): void {
    this.activateAccountForm = this._formBuilder.group({
      'name':['',[Validators.required]],
      'password':['',[Validators.required, Validators.minLength(3)]],
      'repeatPassword':['',[Validators.required]]
    })
    this.getParams();
  }

  /**
   * @description methord is called on forgot password form submission.
   * @returns void
   */
  public activateAccountFormSubmit(): void {
    if (this.activateAccountForm.valid) {
      let activateAccountPayload: ActivateAccountModel = {
        inviteCode: this.token,
        password: this.activateAccountForm.controls['password'].value,
      }
      this._api.request('activateAccount',activateAccountPayload).subscribe((result: SuccessModel)=>{
        this._toastr.success(result.message,'Success', {
          timeOut: environment.TOASTER_TIMEOUT,
          positionClass: environment.TOASTER_POSITION
        })
        this._router.navigate(['login']);
      })
    }
  }

  /**
   * @description methord checks if the password and the retype password are the same
   * @returns void
   */
  public passwordCheck(): void {
    if (this.activateAccountForm.controls['repeatPassword'].value != this.activateAccountForm.controls['password'].value) {
      this.activateAccountForm.controls['repeatPassword'].setErrors({
        isValid: false
      });
    }
  }

  public getParams(): void {
    this.usernameSubscription = this._route.queryParamMap.subscribe((res: any) => {
      this.username = res.params.username;

      this.activateAccountForm.controls['name'].setValue(this.username);
    });
    this.tokenSubscription = this._route.paramMap.subscribe((res: any)=>{
      this.token = res.params.token;

    })
  }
}
